import React, { Fragment, useState } from 'react';
import {
    Row,
    Button,
    Modal, ModalBody, ModalFooter, ModalHeader
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, AxiosPublicAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Conversations_By_Id } from '../../../../../constants/APIs';
import Conversations from '../../../dashboards/components/cards/Conversations';

const STOPFB_URL = process.env.REACT_APP_CHAT_API + '/stopfb';
const RESUMEFB_URL = process.env.REACT_APP_CHAT_API + '/resumefb';

const ConversationPopup = ({
    conversationid
}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [transfertobot, setTransfertobot] = useState(false);
    const [transfertomesseger, setTransfertomesseger] = useState(false);
    const [selectedChat, setselectedChat] = useState();

    const clickBtn = () => {
        handleContactClick(conversationid);
    }
    const handleContactClick = (conversationId) => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Conversations_By_Id}/${conversationId}?gid=${getGroupID()}`,
        })
            .then((response) => {
                setModalVisible(true);
                setselectedChat(response.data);
            })
            .catch((error) => error);
    };

    const toggleMessanger = () => {
        setTransfertomesseger(!transfertomesseger);
    };

    const togglebot = () => {
        setTransfertobot(!transfertobot);
    };
    const toggleConversation = () => {
        setModalVisible(!modalVisible);
    };
    const StopFacebookChat = (botConversationId) => {
        // console.log(botConversationId)
        AxiosPublicAPI({
            method: 'get',
            url: `${STOPFB_URL}/${botConversationId}`,
        }).then((userData) => {
            console.log('stop FB');
            toggleMessanger();
        });
    };
    const ResumeFacebookChat = (botConversationId) => {
        AxiosPublicAPI({
            method: 'get',
            url: `${RESUMEFB_URL}/${botConversationId}`,
        }).then((userData) => {
            console.log('resume FB');
            togglebot();
        });
    };

    const TransferBotToMessanger = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="12" className="mb-1">
                            <Modal
                                isOpen={transfertomesseger}
                                keyboard="false"
                                backdrop="static"
                                toggle={toggleMessanger}
                            >
                                <ModalHeader>Handover to Messenger</ModalHeader>
                                <ModalBody>
                                    <p>
                                        {' '}
                                        Chatbot will stop responding to the user messages, and you
                                        will need to respond from the Facebook Messenger app. You
                                        can anytime give control back to the chatbot for this
                                        Facebook user.{' '}
                                    </p>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={toggleMessanger}>
                                        Continue
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    const TransferToBot = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="12" className="mb-1">
                            <Modal
                                isOpen={transfertobot}
                                keyboard="false"
                                backdrop="static"
                                toggle={togglebot}
                            >
                                <ModalHeader>Handover to Chatbot</ModalHeader>
                                <ModalBody>
                                    <p>
                                        {' '}
                                        Chatbot will start responding to this user messages. You can
                                        anytime take control back from the chatbot for this Facebook
                                        user.
                                    </p>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={togglebot}>
                                        Continue
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Row>
            <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                <Row>
                    {modalVisible === false ?
                        <Colxx xs="12" sm="3" className="mb-1">
                            <i
                                onClick={() => clickBtn()}
                                style={{ cursor: 'pointer' }}
                                className="icon-open" >
                                <svg fill="none" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /></svg>
                            </i>
                        </Colxx> :
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={modalVisible}
                                toggle={toggleConversation}
                                size="xl"
                            >
                                <ModalHeader toggle={toggleConversation}>
                                    Conversation & Visitor Details
                                </ModalHeader>
                                <ModalBody>
                                    {selectedChat && (
                                        <Conversations
                                            selectedChat={selectedChat}
                                            StopFacebookChat={StopFacebookChat}
                                            ResumeFacebookChat={ResumeFacebookChat}
                                        />
                                    )}
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    }
                </Row>
            </Colxx>
        </Row>
    );
}

export default ConversationPopup